import { defineMessages } from 'react-intl';

export default defineMessages({
  fewResultsByProfession: {
    id: 'global_few_results_jobs_snippet_category',
    defaultMessage: 'Job offer similar to {%1$s}',
  },
  fewResultsByLocation: {
    id: 'global_few_results_jobs_snippet_location',
    defaultMessage: 'Jobs within {%1$s}',
  },
});



// WEBPACK FOOTER //
// ./app/common/Snippet/jobs/messages.js